import PropTypes from 'prop-types';
import useInvoice from 'Hooks/useInvoice';
import CardInvoice from './CardInvoice';
import CardInvoiceSkeleton from './CardInvoiceSkeleton';
import { INVOICES_CREATION_STATUSES } from 'Utils/constants';

const pendingStatuses = [
    INVOICES_CREATION_STATUSES.PENDING_SCAN,
    INVOICES_CREATION_STATUSES.PENDING_UPLOAD,
    INVOICES_CREATION_STATUSES.PENDING_SCAN_RETRY,
];

export default function CardInvoiceAsync({ invoiceId, onDelete }) {
    const { invoice, isLoading } = useInvoice(invoiceId, {
        refetchInterval: (data) => (pendingStatuses.includes(data?.status) ? 5000 : false),
    });

    if (isLoading) {
        return <CardInvoiceSkeleton />;
    }

    if (!invoice) return null;

    const showValidate = !pendingStatuses.includes(invoice?.status) && invoice?.is_imported && !invoice?.is_validated;

    return (
        <CardInvoice
            status={invoice.status}
            type={invoice.type}
            subtype={invoice.subtype}
            contactName={invoice.invoice_party_display_name}
            serieFormatted={invoice.identifier}
            isReconciled={invoice.is_reconciled}
            datePayment={invoice.date_payment}
            amount={invoice.amount}
            currency={invoice.currency}
            invoiceId={invoice.id}
            onDelete={onDelete}
            showValidate={showValidate}
        />
    );
}

CardInvoiceAsync.propTypes = {
    invoiceId: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
};
